import * as amplitude from '@amplitude/analytics-browser';
import { Identify } from '@amplitude/analytics-browser';
import AnalyticsEvent from './AnalyticsEvent';
import { IAnalyticsService, TrackEventOptions } from './AnalyticsService';

// Local shape that matches Amplitude's BaseEvent for insert_id support.
type AmplitudeBaseEvent = {
  event_type: string;
  event_properties?: Record<string, unknown>;
  insert_id?: string;
};

class AnalyticsServiceImpl implements IAnalyticsService {
  private defaultEventProperties: Record<string, unknown> = {
    platform: 'web',
    environment: 'production',
  };

  trackEvent(event: AnalyticsEvent, properties?: Record<string, unknown>, options?: TrackEventOptions): void {
    const mergedProperties = { ...this.defaultEventProperties, ...properties };

    if (options?.insertId) {
      const baseEvent: AmplitudeBaseEvent = {
        event_type: event,
        event_properties: mergedProperties,
        insert_id: options.insertId,
      };
      amplitude.track(baseEvent as amplitude.Types.BaseEvent);
    } else {
      amplitude.track(event, mergedProperties);
    }
  }

  trackPageView(page: string): void {
    amplitude.track(AnalyticsEvent.PageView, {
      ...this.defaultEventProperties,
      page,
    });
  }

  identifyUser({ id, email, name, companyId }: { id: number; email: string; name: string; companyId?: number }): void {
    amplitude.setUserId(`${id}-${email}`);

    const identify = new Identify();
    identify.set('user_id', id);
    identify.set('email', email);
    identify.set('name', name);

    if (companyId !== undefined) {
      identify.set('company_id', companyId);
      this.defaultEventProperties = { ...this.defaultEventProperties, company_id: companyId };
    }

    amplitude.identify(identify);
  }

  setCompanyId(companyId: number): void {
    this.defaultEventProperties = { ...this.defaultEventProperties, company_id: companyId };

    const identify = new Identify();
    identify.set('company_id', companyId);
    amplitude.identify(identify);
  }
}

export default AnalyticsServiceImpl;
